import AppConstants from '../constants/AppConstants';

const { FETCH_COOKIES, LOAD_APP_CONFIG, LOAD_COOKIES } = AppConstants;

function loadAppConfig(appConfig) {
  return {
    appConfig,
    type: LOAD_APP_CONFIG
  };
}

/**
 * Tell the reducers to load the given `cookies` as if they came from the
 * user agent's cookies. Used for initializing a server-rendered redux store.
 * @param  {object} cookies
 * @return {object]}
 */
function loadCookies(cookies = {}) {
  return {
    cookies,
    type: LOAD_COOKIES
  };
}

/**
 * Tell the reducers to fetch their cookies from the user-agent.
 * @return {object]}
 */
function fetchCookies() {
  return {
    type: FETCH_COOKIES
  };
}

export default {
  fetchCookies,
  loadAppConfig,
  loadCookies
};
